__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.50.6-4871-amber-user-website-prod-hk-1779/assets/";